const deployment = process.env.DEPLOYMENT || 'production'
export default deployment
